module.exports = __webpack_public_path__ + "img/1247.0e1a6ef3.png";